import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { ComponentIds, DraggableComponent, } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { isRootMountingRail } from "../utils/mountingRailHelpers";
export default class AddDraggableToRootMountingRailSystem extends SystemBase {
    constructor() {
        super(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID);
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.id = "AddDraggableToRootMountingRailSystem";
        this.mandatoryComponents = [COMPONENT_IDS.MOUNTING_RAIL_COMPONENT];
        this.addDraggable = (_entity) => {
            if (!isRootMountingRail(_entity))
                return null;
            return _entity.addComponent(new DraggableComponent());
        };
    }
    onAddComponent(_entity, _newComponent) {
        super.onAddComponent(_entity, _newComponent);
        this.addDraggable(_entity);
    }
    onUpdateComponent(_entity, _oldComponent, _newComponent) {
        super.onUpdateComponent(_entity, _oldComponent, _newComponent);
        this.addDraggable(_entity);
    }
}
